// extracted by mini-css-extract-plugin
module.exports = {"logo":"Layout_logo__2c34V","logo-text":"Layout_logo-text__3tWYw","main":"Layout_main__3OBIG"};